export const BOX = "Etiqueta";
export const FOLDER_EDITING = "Edición de carpeta";
export const BOX_METADATA = "Metadatos de etiqueta";
